// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import { getDeviceList, IDeviceListQuery, fetchDeviceById, getRoadName } from '../api/devices'
import { message } from 'antd'
import { LnglatShift } from 'utils/lnglat-shift'
import { IDevice } from 'constants/device'

const lnglatShift = new LnglatShift()

export type camerasState = {
  cameraList: IDevice[]
  cameraDetails: IDevice
  hoveredCamera: any
  selectedCamera: any
  uploadingCamera: any
}
export const cameras = {
  state: {
    cameraList: [],
    cameraDetails: {},
    hoveredCamera: null,
    selectedCamera: null,
    uploadingCamera: null,
  },
  reducers: {
    updateCityCameras: (state, cameraList) => ({ ...state, cameraList }),
    updateCameraDetails: (state, cameraDetail) => {
      const add = { [cameraDetail.deviceID]: cameraDetail }
      return {
        ...state,
        cameraDetails: { ...state.cameraDetails, ...add }
      }
    },
    updateHoveredCamera: (state, hoveredCamera) => ({ ...state, hoveredCamera }),
    updateSelectedCamera:(state,selectedCamera)=>({...state,selectedCamera}),
    updateUploadingCamera:(state,uploadingCamera)=>({...state,uploadingCamera}),
    clear () {
      return {
        cameraList: [],
        cameraDetails: {},
        hoveredCamera: null,
        selectedCamera: null,
        uploadingCamera: null,
      }
    }
  },
  effects: dispatch => ({
    async fetchCameras (query: IDeviceListQuery = { page: 1, pageSize: 10000 }, rootState) {
      let res
      lnglatShift.clear()
      try {
        // todo implement city section
        res = await getDeviceList(query)
        const devices = res.results.map(d => {
          let { longitude, latitude } = d

          // If lat/lng is (0, 0) and a current city is set, move the camera
          // to city center
          if (longitude === 0 && latitude === 0 && rootState.city.current) {
            longitude = rootState.city.current.longitude
            latitude = rootState.city.current.latitude
          }
          const [offsetLng, offsetLat] = lnglatShift.shift(longitude, latitude)
          return {
            ...d,
            lon: offsetLng,
            lat: offsetLat,
            longitude: offsetLng,
            latitude: offsetLat
          }
        })
        this.updateCityCameras(devices || [])

        // update popup position and content when cameras data was refreshed
        const hoveredCamera = rootState.cameras.hoveredCamera
        if (hoveredCamera) {
          const freshCamera = devices.find(d => d.deviceID === hoveredCamera.deviceID)
          if (freshCamera) {
            let roadName = await getRoadName(freshCamera.deviceID)
            freshCamera.road = roadName
            this.updateHoveredCamera(freshCamera)
          }
        }
        return devices
      } catch (e) {
        message.error('fetch Camera List Error:' + e?.message)
        return
      }
    },
    async fetchCameraDetails ({ deviceID, useCache = true }, rootState) {
      const { cameraDetails } = rootState.cameras
      if (useCache && cameraDetails[deviceID]) {
        return cameraDetails[deviceID]
      }
      let camera
      try {
        camera = await fetchDeviceById(deviceID)
        let roadName = await getRoadName(camera.deviceID)
        camera.road = roadName
      } catch (e) {
        message.error('fetch Camera Details Error:' + e.message)
        return
      }
      if (camera) {
        camera.deviceID = deviceID
        this.updateCameraDetails(camera)
        return camera
      } else {
        message.error('fetch Camera Details Failed')
      }
    }
  })
}
